var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex jcenter",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"c-spinner"})])
}]

export { render, staticRenderFns }